export const pagosKeys = {
  all: ['pagos'] as const,
  lists: () => [...pagosKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...pagosKeys.lists(), filters] as const,
  coordenadas: (clienteId: number) => [...pagosKeys.lists(), 'coordenadas', clienteId] as const,
  // Stats cuelgan de lists() para que invalidar el listado también refresque los KPIs.
  stats: (filters: Record<string, unknown>) => [...pagosKeys.lists(), 'stats', filters] as const,
  fifoPreview: (filters: Record<string, unknown>) =>
    [...pagosKeys.all, 'fifo-preview', filters] as const,
  prepaidPreview: (filters: Record<string, unknown>) =>
    [...pagosKeys.all, 'prepaid-preview', filters] as const,
  details: () => [...pagosKeys.all, 'detail'] as const,
  detail: (id: number) => [...pagosKeys.details(), id] as const,
  boleta: (id: number) => [...pagosKeys.all, 'boleta', id] as const,
  // Opcion list for the user filter: users associated with payments.
  users: () => [...pagosKeys.all, 'users'] as const,
};
